export default __webpack_public_path__ + "static/media/tech_graphics.3f6b23a0.png";